export const TABS = {
  ACTIVE_DEALS: 'active-deals',
  PRE_LOCK_PROPERTIES: 'pre-lock-properties',
};
